import moment from "moment";

export const ACTIONS = {
  UPDATE_DATE_RANGE: "UPDATE_DATE_RANGE",
} as const

type LatestDataframesFormActionsTypes = keyof typeof ACTIONS

interface LatestDataframesFormPayload {
  startDate: moment.Moment,
  endDate: moment.Moment,
  fullTrace: boolean,
}

interface UpdateDateRangeAction {
  type: typeof ACTIONS.UPDATE_DATE_RANGE,
  payload: {
    formData: LatestDataframesFormPayload
  }
}

type LatestDataframesFormActions =
  | UpdateDateRangeAction

export type UpdateDateRangePayload = UpdateDateRangeAction['payload']['formData']

export const updateDateRange = ({ startDate, endDate, fullTrace }: UpdateDateRangePayload): UpdateDateRangeAction => {
  return {
    type: ACTIONS.UPDATE_DATE_RANGE,
    payload: {
      formData: {
        startDate,
        endDate,
        fullTrace
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Redux/Actions/LatestDataframesForm.Actions.ts